/**
 * GL client callers against the SERVER-owned wire contract —
 * docs/gl-api-wire-contract.md (QLearn-service repo). The ROW1 activation gate
 * rejected the flip because this layer was built against the mock and diverged
 * from the real controllers (B4/B5: wrong route, wrong method, wrong field
 * name, missing /qlearn prefix); every caller below now matches the contract
 * table row-for-row and is pinned by gl-api.contract.test.js. Zero client-side
 * event emission here — card/deck events are server-emitted.
 */
import { glFetch } from "./gl-fetch";

// Contract row 2 — POST /gl/card/draft at grade time. `gradeEventId` is the
// question_history id returned by the answer-submit response; the server
// re-verifies ownership + question binding and resolves the hint trail itself
// (a caller-asserted trail is never trusted), so neither hintTrail nor
// gradedCorrect ride from the client.
export const draftCard = ({ questionId, gradeEventId, whyState, why }) =>
  glFetch("/gl/card/draft", { method: "POST", body: { questionId, gradeEventId, whyState, why } });

// Contract row 3 — the draft LIST is GET /gl/card/drafts (owner-scoped, no
// params; the BARE-array response). GET /gl/card/draft was the gate-found 405.
export const listDraftCards = () => glFetch("/gl/card/drafts");

export const acceptCard = (cardId) =>
  glFetch(`/gl/card/${encodeURIComponent(cardId)}/accept`, { method: "POST" });

export const discardCard = (cardId) =>
  glFetch(`/gl/card/${encodeURIComponent(cardId)}/discard`, { method: "POST" });

// Contract row 5 — edit is POST /gl/card/{id}/edit and the optimistic-
// concurrency field is `version` (P13); a stale token 409s and the caller
// shows an explicit re-load UX (never a silent retry/reapply). The server edit
// surface accepts front/back only.
export const editCard = (cardId, { front, back, version }) =>
  glFetch(`/gl/card/${encodeURIComponent(cardId)}/edit`, {
    method: "POST",
    body: { front, back, version }
  });

// Contract row 7 — {due, counts}.
export const getDue = () => glFetch("/gl/deck/due");

// Contract row 8 — returns the BARE rescheduled DueCardDto (no counts).
export const recall = (cardId, outcome) =>
  glFetch("/gl/deck/recall", { method: "POST", body: { cardId, outcome } });
